import React from 'react';
import { motion } from 'framer-motion';
import { Search, Zap, DollarSign, Handshake, ShieldCheck, ArrowRight } from 'lucide-react';
const CALENDLY_URL = 'https://calendly.com/vantixcredit/diagnostico-de-credito';
const offerings = [{
  number: '01',
  icon: Search,
  title: 'Diagnostico Personalizado',
  description: 'Realizamos un analisis profundo de tu perfil crediticio para entender exactamente donde estas y diseñar una estrategia que funcione especificamente para ti. Ya que cada caso es unico y se trata de forma totalmente personalizada.'
}, {
  number: '02',
  icon: Zap,
  title: 'Estrategia de Optimizacion Experta',
  description: 'Nuestro equipo diseña un plan paso a paso para remover cuentas negativas y errores que pueda tener tu reporte de credito en vias de mejorar, estructurar y fortalecer tu perfil personal. Nuestro objetivo es claro: que los bancos e instituciones financieras te vean como un candidato ideal para aprobarte con las mejores condiciones e intereses mas bajos.'
}, {
  number: '03',
  icon: DollarSign,
  title: 'Acceso a Capital Real',
  description: 'Una vez optimizado tu credito, logramos abrir las puertas al financiamiento. Desde $35,000 hasta $50,000 dolares a traves de uno o mas bancos, lineas de credito, prestamos personales y credit card stacking estrategico para maximizar tu capital para que puedas impulsar tu negocio, hacer inversiones o emprender desde cero.'
}, {
  number: '04',
  icon: Handshake,
  title: 'Acompañamiento en Todo el Proceso',
  description: 'Contaras con atencion personalizada en cada etapa del proceso donde podras consultar y resolver las dudas que tengas acerca de tu caso. Recibiras actualizaciones sobre los resultados que vamos obteniendo y contaras con nuestra guia para llegar a los +700 puntos.'
}];
export function Commitment() {
  return <section className="bg-black py-20 md:py-24 px-4 sm:px-6 lg:px-8 border-t border-white/5 relative overflow-hidden" data-id="element-46" data-mp="3jkhg6hz8h7wz">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(245,158,11,0.05),transparent_50%)] pointer-events-none" data-id="element-47" data-mp="3l37u1ysc59jb" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-48" data-mp="3c201zygex4xo">
        {/* Heading */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-center mb-14 md:mb-16" data-id="element-49" data-mp="3c4ckccq31hb9">
          <span className="inline-block text-xs font-semibold tracking-[0.3em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-6" data-id="element-50" data-mp="2xcu8mr49a8xp">
            Nuestro Compromiso
          </span>
          <h2 className="text-4xl md:text-6xl font-bold text-white tracking-tight mb-6 leading-[1.1]" data-id="element-51" data-mp="2ocp0ger8n6ih">
            Que{' '}
            <span className="italic font-black bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-52" data-mp="24rf2ahxduhpr">
              Ofrecemos
            </span>
          </h2>
          <p className="text-lg md:text-xl text-white/50 font-light max-w-2xl mx-auto" data-id="element-53" data-mp="2epl30w7gdht1">
            Mas que un servicio, una asociacion estrategica para transformar tu
            vida financiera de principio a fin.
          </p>
        </motion.div>

        {/* 2x2 grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-54" data-mp="2ir6mj0ehsuc7">
          {offerings.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.8,
          delay: index % 2 * 0.1,
          ease: [0.16, 1, 0.3, 1]
        }} className="p-8 md:p-10 rounded-3xl bg-gradient-to-b from-white/[0.04] to-white/[0.01] border border-white/[0.08] hover:border-amber-500/20 transition-all duration-500" data-id="element-55" data-mp="2xe9jn5ywl0z0" data-mpi={index}>
              <div className="flex items-center gap-4 mb-6" data-id="element-56" data-mp="1eflci6qd66ds">
                <div className="h-12 w-12 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/20 flex items-center justify-center shrink-0" data-id="element-57" data-mp="gsut3ozpi5rm">
                  <item.icon className="h-6 w-6 text-amber-400" strokeWidth={2} data-id="element-58" data-mp="lu20hmxxt2xr" />
                </div>
                <span className="text-sm font-semibold tracking-[0.3em] bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent" data-id="element-59" data-mp="utozk2371wnn">
                  {item.number}
                </span>
              </div>

              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-60" data-mp="265zm3qrcgwjn">
                {item.title}
              </h3>
              <p className="text-white/50 font-light leading-relaxed" data-id="element-61" data-mp="3qrxwucyq4yxf">
                {item.description}
              </p>
            </motion.div>)}
        </div>

        {/* Guarantee banner */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="rounded-3xl border border-amber-500/30 bg-gradient-to-r from-amber-500/[0.08] via-amber-500/[0.03] to-transparent shadow-2xl shadow-amber-500/5 p-8 md:p-12" data-id="element-62" data-mp="3hv6w3n988vwi">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8" data-id="element-63" data-mp="x69eephrrfw7">
            {/* Icon */}
            <div className="h-16 w-16 rounded-2xl bg-gradient-to-b from-amber-300/20 to-amber-600/10 border border-amber-500/30 flex items-center justify-center shrink-0" data-id="element-64" data-mp="s8r2cq8ggkjz">
              <ShieldCheck className="h-8 w-8 text-amber-400" strokeWidth={2} data-id="element-65" data-mp="1g3t0p77h89l5" />
            </div>

            {/* Text */}
            <div className="flex-1" data-id="element-66" data-mp="12dfx1h1mbh1m">
              <div className="text-xs font-semibold tracking-[0.25em] uppercase bg-gradient-to-b from-amber-300 to-amber-500 bg-clip-text text-transparent mb-4" data-id="element-67" data-mp="12ablfyltpj0x">
                Garantia de Servicio
              </div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-tight" data-id="element-68" data-mp="1z25fb8h5qbo4">
                Si no logramos una mejora visible en tu reporte de credito en
                120 dias, te devolvemos el{' '}
                <span className="bg-gradient-to-b from-amber-200 via-amber-400 to-amber-600 bg-clip-text text-transparent" data-id="element-69" data-mp="1q0xnn995c930">
                  100%
                </span>{' '}
                de tu inversion
              </h3>
              <p className="text-white/50 font-light leading-relaxed" data-id="element-70" data-mp="eo506ane26sr">
                Este acuerdo lo realizamos bajo contrato firmado por ambas
                partes para garantizar que todo se haga correctamente.
              </p>
            </div>

            {/* CTA */}
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-600 hover:brightness-110 text-black font-semibold px-7 py-4 rounded-full transition-all text-base shadow-2xl shadow-amber-500/30 shrink-0 whitespace-nowrap" data-id="element-71" data-mp="g2o7nq095nt7">
              Empieza Ahora
              <ArrowRight className="h-4 w-4" data-id="element-72" data-mp="3tcc5j1mpv266" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}